module.exports = __webpack_public_path__ + "static/img/cambio-climatico.c69f9114.png";